import { session$ } from '@/features/auth/store'
import { useSelector } from '@/libs/state'

const useCurrentUser = () => {
	const user = useSelector(() => session$.user.get())
	return { user }
}

export { useCurrentUser }
